export default "__VITE_ASSET__g0cjhJdm__"